"use client";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useRouter } from "next/navigation.js";
import { useIntl } from "react-intl";

import { usePreviousPath } from "@/shared/lib/use-previous-path.js";

interface AppBarBackButtonProps {
  fallbackHref?: string;
}

export function ViewBoxAppBarBackButton({
  fallbackHref,
}: AppBarBackButtonProps) {
  const { formatMessage } = useIntl();
  const router = useRouter();

  const prev = usePreviousPath();

  function handleGoBack() {
    if (!prev) {
      router.push(fallbackHref ?? "/");

      return;
    }

    if (prev === "/") {
      router.push(prev);

      return;
    }

    router.back();
  }

  return (
    <Tooltip title={formatMessage({ id: "app_bar_go_back" })}>
      <IconButton color="inherit" onClick={handleGoBack}>
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );
}
